module.exports = __webpack_public_path__ + "img/motoboy-01.0b50cce8.svg";